import { TableViewStore, BaseListViewStore, QueryPickerStore } from "core/stores";
import { FacilityOrderService } from "application/facility-order/services";
import { PersonService } from 'application/person/services';
import { BaasicDropdownStore } from 'core/stores'
import _ from 'lodash';
import { toDate, getErrorMessage, isDeveloper } from 'core/utils';
import { FacilityService } from "application/facility/services";
import { ScheduleService } from "application/schedule/services";
import { action, observable } from 'mobx';

class NikoFacilityOrderListViewStore extends BaseListViewStore {
	@observable accessor initFetch = true;
	constructor(rootStore) {
        const facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			autoInit: true,
			name: 'niko-facility-order',
			routes: {
				edit: id => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.edit').pattern.replace(":id", id));
				},
				facilityPreview: id => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", id));
				},
				orderingCalendar: async item => {
					const typeResponse = await scheduleService.getTypes();
					var calendarType = _.find(typeResponse.item, { abrv: 'ordering' });
					let intakeRep = item.intakeRepId ? `intakeRepId=${item.intakeRepId}&` : '';
					window.open(`${this.rootStore.routerStore.findRoute("master.app.main.schedule.calendar").pattern}?${intakeRep}calendarTypeId=${calendarType.id}&facilityId=${item.facilityId}`);
				}
			},
			actions: () => {
				return {
					find: async params => {
						if (this.initFetch) {
							this.initFetch = false;
							if (this.queryUtility.filter.userRepId === undefined && !isDeveloper(this.rootStore.userStore.user.userName)) {
                                const response = await personService.getByUser(this.rootStore.userStore.applicationUser.id);

                                if (response) {
                                    this.queryUtility.filter.set('userRepId', response.data.id);
                                    params.userRepId = response.data.id;
                                }
							}
						}
						const response = await facilityOrderService.find(_.extend({ isNiko: true, ...params }, { embed: 'Facility,Facility.IntakeRep,ImportHeaderStatus' }));
						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
									facility: item.facility && item.facility.name,
									intakeRep: item.facility && item.facility.intakeRep && item.facility.intakeRep.fullName,
									status: item.importHeaderStatus && item.importHeaderStatus.name && `${item.importHeaderStatus.name == "Order Summary" ? (item.isStatusCompleted ? "Order" : "Order Summary") : item.importHeaderStatus.name}${item.importHeaderStatus.name !== 'New' && item.importHeaderStatus.name !== 'Reviewed' && item.importHeaderStatus.name !== 'Processing' ? item.isStatusCompleted ? ' Complete' : ' in Progress' : ''}`,
									dateCreated: toDate(item.dateCreated),
									dateOfService: item.dateOfService && toDate(item.dateOfService),
								}
								);
							}))
						});
						return responseData;
					},
					delete: async item => {
						return await facilityOrderService.deleteNikoFacilityOrder({ id: item.id });
					},
				};
			},
		});

        this.facilityOrderService = facilityOrderService;
        this.createdAtPickerStore = new QueryPickerStore();
        this.dateOfServicePickerStore = new QueryPickerStore();
        this.personStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async (term) => {
				const response = await personService.find({ searchQuery: term, rpp: 200, isActive: true });
				return _.map(response.data.item, item => {
					return {
						id: item.id,
						name: item.firstName + ' ' + item.lastName
					};
				});
			}
		});
        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async (term) => {
				const response = await facilityService.find({ isNiko: true, searchQuery: term, rpp: 100 });
				return _.map(response.data.item, item => {
					return {
						id: item.id,
						name: item.name
					};
				});
			}
		});
        this.queryUtility.onResetFilter = () => {
			this.facilityStore.setValue(null);
			this.facilityStore.filterTerm = "";

			this.personStore.setValue(null);
			this.personStore.filterTerm = "";

			this.createdAtPickerStore.reset();
			this.dateOfServicePickerStore.reset();
		}

        const userRoles = this.rootStore.userStore.user.roles;
        this.isAdmin = userRoles.includes("Administrators");
        this.isAccountManager = userRoles.includes("AccountManagers");

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'facility',
						title: "FACILITY_ORDER.LIST.COLUMNS.FACILITY",
						onClick: item => this.showTemplates(item),
					},
					{
						key: 'intakeRep',
						title: "FACILITY_ORDER.LIST.COLUMNS.INTAKE_SPECIALIST",
						onClick: item => this.showTemplates(item),
					},
					{
						key: 'dateOfService',
						title: "FACILITY_ORDER.LIST.COLUMNS.DATE_OF_SERVICE",
						onClick: item => this.showTemplates(item),
						width: 150
					},
					{
						key: 'status',
						title: "FACILITY_ORDER.LIST.COLUMNS.STATUS",
						onClick: item => this.showTemplates(item),
					},
					{
						key: 'dateCreated',
						title: "FACILITY_ORDER.LIST.COLUMNS.DATE_CREATED",
						onClick: item => this.showTemplates(item),
						width: 150
					},
				],
				actions: {
					onEdit: item => this.routes.edit(item.facilityId),
					onPreview: (item) => this.routes.facilityPreview(item.facilityId),
					orderingCalendar: (item) => this.routes.orderingCalendar(item),
					onDelete: (this.isAdmin || this.isAccountManager) ? async (item) => this.onDelete(item) : null
				},
			})
		);
    }

	async showTemplates(item) {
		let targetPage = (await this.facilityOrderService.getNikoTargetPage(item.id)).data;
        return window.open(`${this.rootStore.routerStore.findRoute('master.app.main.niko-facility-order.' + targetPage + '-preview').pattern.replace(':id', item.id)}`, '_blank');
    }

	@action.bound
	async onDelete(item) {
		if (item.sendOrder){
			this.rootStore.notificationStore.error('This order can’t be deleted because it has been sent.');
			return;
		}
		this.rootStore.modalStore.showConfirm(
			'FACILITY_ORDER.LIST.COLUMNS.DELETE_MESSAGE',
			async () => {
				try {
					await this.actions.delete(item);
					this.rootStore.notificationStore.success('Facility Order successfully deleted.');
					this.queryUtility.fetch();
				} catch (err) {
					this.rootStore.notificationStore.error(getErrorMessage(err, 'Error occured while trying to delete the Facility Order.'));
				}
			}
		);
	}
}

export default NikoFacilityOrderListViewStore;